export { default } from "./[id]";
export * from "./query";
